import * as actionTypes from '../actions/types';
import { AnteProyectoValidation, BackofficeStats, BackofficeFilters } from '../../types/backoffice.ts';

export interface BackofficeState {
  activeTab: 'identity' | 'anteproyectos';
  
  pendingAnteProyectos: AnteProyectoValidation[];
  selectedAnteProyecto: AnteProyectoValidation | null;
  anteProyectosLoading: boolean;
  anteProyectosError: string | null;
  
  stats: BackofficeStats;
  statsLoading: boolean;
  
  pagination: {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  };
  
  filters: BackofficeFilters;
  
  validationLoading: boolean;
}

const INITIAL_STATE: BackofficeState = {
  activeTab: 'identity',
  
  pendingAnteProyectos: [],
  selectedAnteProyecto: null,
  anteProyectosLoading: false,
  anteProyectosError: null,
  
  stats: {
    totalPendingIdentities: 0,
    totalPendingAnteProyectos: 0,
    totalApprovedToday: 0,
    totalRejectedToday: 0,
  },
  statsLoading: false,
  
  pagination: {
    currentPage: 1,
    itemsPerPage: 9,
    totalItems: 0,
    totalPages: 0,
  },
  
  filters: {
    searchTerm: '',
    status: 'all',
    dateFrom: null,
    dateTo: null,
    minBudget: null,
    maxBudget: null,
    categoryId: null,
  },
  
  validationLoading: false,
};

const backofficeReducer = (state = INITIAL_STATE, action: any): BackofficeState => {
  switch (action.type) {
    case actionTypes.SET_BACKOFFICE_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
      
    case actionTypes.FETCH_PENDING_ANTEPROYECTOS_LOADING:
      return {
        ...state,
        anteProyectosLoading: true,
        anteProyectosError: null,
      };
      
    case actionTypes.FETCH_PENDING_ANTEPROYECTOS_SUCCESS:
      return {
        ...state,
        pendingAnteProyectos: action.payload.data,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.page,
          totalItems: action.payload.total,
          totalPages: action.payload.totalPages,
        },
        anteProyectosLoading: false,
        anteProyectosError: null,
      };
      
    case actionTypes.FETCH_PENDING_ANTEPROYECTOS_ERROR:
      return {
        ...state,
        anteProyectosLoading: false,
        anteProyectosError: action.payload,
      };
      
    case actionTypes.SET_SELECTED_ANTEPROYECTO:
      return {
        ...state,
        selectedAnteProyecto: action.payload,
      };
      
    case actionTypes.FETCH_BACKOFFICE_STATS_LOADING:
      return {
        ...state,
        statsLoading: true,
      };
      
    case actionTypes.FETCH_BACKOFFICE_STATS_SUCCESS:
      return {
        ...state,
        stats: action.payload,
        statsLoading: false,
      };
      
    case actionTypes.SET_BACKOFFICE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
        pagination: {
          ...state.pagination,
          currentPage: 1,
        },
      };
      
    case actionTypes.SET_BACKOFFICE_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: action.payload,
        },
      };
      
    case actionTypes.VALIDATE_ANTEPROYECTO_LOADING:
      return {
        ...state,
        validationLoading: true,
      };
      
    case actionTypes.VALIDATE_ANTEPROYECTO_SUCCESS:
      return {
        ...state,
        validationLoading: false,
        pendingAnteProyectos: state.pendingAnteProyectos.filter(
          (proyecto) => proyecto.id.toString() !== action.payload.id.toString()
        ),
        selectedAnteProyecto: null,
      };
      
    case actionTypes.VALIDATE_ANTEPROYECTO_ERROR:
      return {
        ...state,
        validationLoading: false,
      };
      
    default:
      return state;
  }
};

export default backofficeReducer;

